import { useCallback, useEffect, useRef, useState } from 'react'
import { Outlet } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import { useTranslation } from 'react-i18next'

import PageHeader from '../common/PageHeader/PageHeader'
import CreateEnrollmentWizard from './components/CreateEnrollmentWizard'
import EnrollmentsBillingContext from './EnrollmentsBillingContext'
import { setCurrentTab } from '../../actions/commonActions'

import classes from './EnrollmentsBillingLayout.module.scss'

const EnrollmentsBillingLayout = () => {
  const dispatch = useDispatch()
  const { t } = useTranslation()
  const [showCreateWizard, setShowCreateWizard] = useState(false)
  const refreshRef = useRef(null)

  const registerRefresh = useCallback((fn) => { refreshRef.current = fn }, [])

  useEffect(() => {
    dispatch(setCurrentTab(t('sidebar.enrollmentsBilling')))
  }, [dispatch, t])

  const createButton = (
    <button
      className={classes.createButton}
      onClick={() => setShowCreateWizard(true)}
      aria-label={t('enrollmentsBilling.layout.createEnrollment')}
    >
      {t('enrollmentsBilling.layout.createEnrollment')}
    </button>
  )

  return (
    <EnrollmentsBillingContext.Provider value={{ registerRefresh }}>
      <div id='enrollmentsBillingLayout' className={classes.layout}>
        <PageHeader title={t('sidebar.enrollmentsBilling')} actionComponent={createButton} />
        <Outlet />
      </div>

      {showCreateWizard && (
        <CreateEnrollmentWizard
          onClose={() => setShowCreateWizard(false)}
          onCreated={() => refreshRef.current?.()}
        />
      )}
    </EnrollmentsBillingContext.Provider>
  )
}

export default EnrollmentsBillingLayout
